import moment from 'moment';
import { isEmpty } from 'lodash-es';

export const monthLater = (amount, asOfDate = Date.now()) => moment(asOfDate).add(amount, 'month').format('YYYY-MM-DD');
export const weekLater = (amount, asOfDate = Date.now()) => moment(asOfDate).add(amount, 'week').format('YYYY-MM-DD');
export const dayLater = (amount, asOfDate = Date.now()) => moment(asOfDate).add(amount, 'day').format('YYYY-MM-DD');

export const monthAgo = (amount, asOfDate = Date.now()) => moment(asOfDate).subtract(amount, 'month').format('YYYY-MM-DD');
export const weekAgo = (amount, asOfDate = Date.now()) => moment(asOfDate).subtract(amount, 'week').format('YYYY-MM-DD');
export const dayAgo = (amount, asOfDate = Date.now()) => moment(asOfDate).subtract(amount, 'day').format('YYYY-MM-DD');

export const defaultRangeDate = (date, format) => {
  const dateRange = date?.split?.('~');
  if (isEmpty(dateRange)) return undefined;
  const [from, to] = dateRange;
  return [moment(from, format), moment(to, format)];
};
